import { z } from "zod";

export const scheduleSchema = z
	.object({
		stageId: z.string().min(1, "Selecione a etapa."),
		startDate: z.string().min(1, "Informe a data de início."),
		endDate: z.string().min(1, "Informe a data de término."),
	})
	.refine((values) => values.endDate >= values.startDate, {
		message: "A data de término deve ser igual ou posterior ao início.",
		path: ["endDate"],
	});

export type ScheduleFormValues = z.infer<typeof scheduleSchema>;
